"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilterButton = exports.StyledLeftFilterHeaderWrapper = exports.StyledFiltersWrapper = exports.StyledSearchFilterHeaderRow = exports.StyledHeaderContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeaderContainer = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.palette.common.white};
  height: ${({ theme }) => theme.spacing(11)};
`;
exports.StyledSearchFilterHeaderRow = styled_components_1.default.div `
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledFiltersWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
exports.StyledLeftFilterHeaderWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  flex: 1;
  align-items: center;
`;
exports.StyledFilterButton = (0, styled_components_1.default)(ui_components_1.Button) `
  height: ${({ theme }) => theme.spacing(6)};
`;
